import { InspectionImageMeta } from './types';

export const getCurrentPosition = (): Promise<{ latitude: number | null; longitude: number | null }> => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ latitude: null, longitude: null });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        });
      },
      () => {
        resolve({ latitude: null, longitude: null });
      },
      {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 0,
      }
    );
  });
};

export const createMetaFromSource = async (
  id: string,
  caption: string,
  source: 'camera' | 'gallery'
): Promise<InspectionImageMeta> => {
  const { latitude, longitude } = await getCurrentPosition();

  return {
    id,
    caption,
    damaged: false,
    latitude,
    longitude,
    createdAt: new Date().toISOString(),
    timestamp: new Date().toISOString(),
    source,
  };
};
